import React from "react";
import { useMessageSource } from "react-message-source";
import Typography from "../../../ui/widgets/typography";
import TypographyContainer from "../../../ui/layout/page/typography-container/typography-base-container";
import TypographyItemContainer from "../../../ui/layout/page/typography-container/typography-item-container";
import Table from "../../../ui/widgets/table-light";
import "../../../ui/widgets/table-light/styles.scss";
import TableBody from "../../../ui/widgets/table-light/body";
import TableHeader from "../../../ui/widgets/table-light/head";
import TableRow from "../../../ui/widgets/table-light/row";
import TableCell from "../../../ui/widgets/table-light/cell";
import { ScdAccordion } from "../../../ui/widgets/accordion";
import { ScdAccordionSummary } from "../../../ui/widgets/accordion/summary";
import { ScdAccordionDetails } from "../../../ui/widgets/accordion/details";

export default function Details(): React.JSX.Element {
  const { getMessage } = useMessageSource();

  return (
    <ScdAccordion>
      <ScdAccordionSummary>
        <Typography variant="body2">
          {getMessage("InsurancePlusOptional.include.rates.title")}
        </Typography>
      </ScdAccordionSummary>
      <ScdAccordionDetails>
        <TypographyContainer>
          <TypographyItemContainer>
            <Typography variant="body2">
              {getMessage("InsurancePlusOptional.include.rates.text")}
            </Typography>
          </TypographyItemContainer>
          <TypographyItemContainer>
            <div className="scd-light-table-container">
              <Table>
                <TableHeader>
                  <TableRow>
                    <TableCell align="left" className="cell-width-m">
                      {getMessage(
                        "InsurancePlusOptional.include.table.header1",
                      )}
                    </TableCell>
                    <TableCell align="right">
                      {getMessage(
                        "InsurancePlusOptional.include.table.header2",
                      )}
                    </TableCell>
                    <TableCell align="right">
                      {getMessage(
                        "InsurancePlusOptional.include.table.header3",
                      )}
                    </TableCell>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  <TableRow>
                    <TableCell align="left">
                      <div
                        className="scd-cell-content"
                        dangerouslySetInnerHTML={{
                          __html: getMessage(
                            "InsurancePlusOptional.include.table.cell11",
                          ),
                        }}
                      />
                    </TableCell>
                    <TableCell align="right">
                      <div className="scd-cell-content">
                        {getMessage(
                          "InsurancePlusOptional.include.table.cell11.values",
                        )}
                      </div>
                    </TableCell>
                    <TableCell align="right">
                      <div className="scd-cell-content">
                        {getMessage(
                          "InsurancePlusOptional.include.table.cell12.values",
                        )}
                      </div>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell align="left">
                      <div
                        className="scd-cell-content"
                        dangerouslySetInnerHTML={{
                          __html: getMessage(
                            "InsurancePlusOptional.include.table.cell21",
                          ),
                        }}
                      />
                    </TableCell>
                    <TableCell align="right">
                      <div
                        className="scd-cell-content"
                        dangerouslySetInnerHTML={{
                          __html: getMessage(
                            "InsurancePlusOptional.include.table.cell21.values",
                          ),
                        }}
                      />
                    </TableCell>
                    <TableCell align="right">
                      <div
                        className="scd-cell-content"
                        dangerouslySetInnerHTML={{
                          __html: getMessage(
                            "InsurancePlusOptional.include.table.cell22.values",
                          ),
                        }}
                      />
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </div>
          </TypographyItemContainer>
        </TypographyContainer>
      </ScdAccordionDetails>
    </ScdAccordion>
  );
}
